module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('div', {
    staticClass: "tabs-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: true
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.getAuthInspirationVideos) ? _c('div', {
    staticClass: "row yourFaves"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.getAuthInspirationVideos), function(video) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin"
    }, [_c('img', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      staticClass: "jw-img",
      attrs: {
        "alt": video.title,
        "src": video.image
      },
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(video.mediaid)
        }
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(video.title))])])
  })], 2) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_c('br'), _vm._v(" "), _c('i', {
    staticClass: "nav-icon inspiration-pink-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('br'), _c('span', [_vm._v("INSPIRATION")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "mostRecent"
  }, [_c('button', {
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                                            most recent\n                                            "), _c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Sort by")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-33b9632b", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33b9632b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/Inspiration.vue